export default __webpack_public_path__ + "static/darkthemelogo-08fbc8b80e5ef65d138c6c8c0b72b579.svg";